export default {
    LIST_STOCK_REQUEST: 'LIST_STOCK_REQUEST',
    LIST_STOCK_SUCCESS: 'LIST_STOCK_SUCCESS',
    LIST_STOCK_FAILURE: 'LIST_STOCK_FAILURE',

    ADD_STOCK_REQUEST: 'ADD_STOCK_REQUEST',
    ADD_STOCK_SUCCESS: 'ADD_STOCK_SUCCESS',
    ADD_STOCK_FAILURE: 'ADD_STOCK_FAILURE',
};